import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=95c0a232&scoped=true"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=95c0a232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0a232",
  null
  
)

export default component.exports